import { render, staticRenderFns } from "./MSGroupMembersPending.vue?vue&type=template&id=365f6098&scoped=true"
import script from "./MSGroupMembersPending.vue?vue&type=script&lang=js"
export * from "./MSGroupMembersPending.vue?vue&type=script&lang=js"
import style0 from "./MSGroupMembersPending.vue?vue&type=style&index=0&id=365f6098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365f6098",
  null
  
)

export default component.exports